import {
  type ComponentPropsWithoutRef,
  forwardRef,
  type ChangeEventHandler,
} from "react";
import styles from "./Switch.module.scss";
import { cn } from "@/shared/lib/utils";

interface SwitchProps extends ComponentPropsWithoutRef<"input"> {
  switchSize?: "M" | "L";
  onCheckedChange?: (checked: boolean) => void;
}

export const Switch = forwardRef<HTMLInputElement, SwitchProps>(
  (
    { className, switchSize = "L", onCheckedChange, onChange, ...props },
    ref,
  ) => {
    const handleChange: ChangeEventHandler<HTMLInputElement> = (e) => {
      if (onCheckedChange) {
        onCheckedChange(e.target.checked);
      }
      if (onChange) {
        onChange(e);
      }
    };

    return (
      <label
        className={cn(
          styles.switch,
          styles[switchSize.toLowerCase()],
          className,
        )}
      >
        <input
          ref={ref}
          type="checkbox"
          className={styles.input}
          onChange={handleChange}
          {...props}
        />
        <span className={styles.slider}></span>
      </label>
    );
  },
);
